import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconAllInclusive = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconAllInclusive",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M220-260q-92 0-156-64T0-480t64-156 156-64q37 0 71 13t61 37l68 62-60 54-62-56q-16-14-36-22t-42-8q-58 0-99 41t-41 99 41 99 99 41q22 0 42-8t36-22l310-280q27-24 61-37t71-13q92 0 156 64t64 156-64 156-156 64q-37 0-71-13t-61-37l-68-62 60-54 62 56q16 14 36 22t42 8q58 0 99-41t41-99-41-99-99-41q-22 0-42 8t-36 22L352-310q-27 24-61 37t-71 13"
  })
}));
IconAllInclusive.displayName = 'IconAllInclusive';